<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="400" overlay-color="#fff" :overlay-opacity="0.7" @click:outside="closeDialog">
      <v-card>
        <v-card-title class="headline">Skift henviser (samme klinik)</v-card-title>
        <v-card-text class="py-4">
          <template v-if="isCanChangeClinic">
            <v-autocomplete v-model="manualClinicId" :items="activeClinics" :disabled="editLoading" :loading="activeClinicsLoading" @change="manualDoctorId = null" item-value="id" item-text="name" label="Ny klinik"/>
            <v-autocomplete v-model="manualDoctorId" :items="manualDoctors" :disabled="editLoading || !manualClinicId" item-value="id" item-text="fullName" label="Ny henviser"/>
          </template>
          <v-autocomplete v-else v-model="newDoctorId" :items="doctors" :disabled="editLoading" item-value="id" item-text="name" label="Henviser"/>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed color="primary" @click="isCanChangeClinic ? openConfirmDialog() : changeDoctorId()" :loading="editLoading" :disabled="editLoading || (isCanChangeClinic && !manualDoctorId)">Gem</v-btn>
          <v-btn color="black darken-1" text @click="closeDialog" :disabled="editLoading">Annuller</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="600" overlay-color="#fff" :overlay-opacity="0.7">
      <v-card>
        <v-card-title class="mb-4">
          <div>
            <div class='mb-2'>Du er ved at sætte denne henvisning til at tilhøre:</div>
            <div><strong>Klinik:</strong> {{manualClinicName}}</div>
            <div class='mb-2'><strong>Henviser:</strong> {{manualDoctorName}}</div>
            <div>Er du sikker? Når du først har skiftet denne kan du ikke ændre det igen.</div>
          </div>
        </v-card-title>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="closeConfirmDialog(); changeDoctorId();">Gennemfør</v-btn>
          <v-btn color="black darken-1" text @click="closeConfirmDialog">Annuller</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import api from '@/api/api';
  import methods from '@/utils/methods';

  export default {
    name: 'OverviewEditDentistDialog',

    props: ['dialog', 'visitItem'],

    data: function () {
      return {
        editLoading: false,
        dentistDialog: false,
        confirmDialog: false,
        newDoctorId: null,
        manualClinicId: null,
        manualDoctorId: null,
      };
    },

    watch: {
      dialog: function (val) {
        if (val) {
          this.manualClinicId = null;
          this.manualDoctorId = null;
          this.visitItem.doctorId && (this.newDoctorId = this.visitItem.doctorId);
        }
      },
    },

    computed: {
      isAdmin: function () {
        return this.$store.getters.isAdmin;
      },
      isCanChangeClinic: function () {
        return this.isAdmin && this.visitItem.canChangeClinic;
      },
      doctors: function () {
        let allDoctors = this.$store.state.doctors;
        let filteredDoctors = allDoctors.filter(doctor => doctor.clinicId === this.visitItem.clinicId);
        return filteredDoctors ? filteredDoctors : [];
      },
      manualDoctors: function () {
        let allDoctors = this.$store.state.doctors;
        let filteredDoctors = allDoctors.filter(doctor => doctor.clinicId === this.manualClinicId);
        return filteredDoctors ? filteredDoctors : [];
      },
      manualClinicName: function () {
        return this.activeClinics.find(clinic => clinic.id === this.manualClinicId)?.name || '';
      },
      manualDoctorName: function () {
        return this.manualDoctors.find(doctor => doctor.id === this.manualDoctorId)?.fullName || '';
      },
      activeClinics: function () {
        return this.$store.state.activeClinics;
      },
      activeClinicsLoading: function() {
        return this.$store.state.activeClinicsLoading;
      },
    },

    methods: {
      closeDialog: function () {
        this.$emit('closeDialog');
      },
      openConfirmDialog: function () {
        this.confirmDialog = true;
      },
      closeConfirmDialog: function () {
        this.confirmDialog = false;
      },
      changeDoctorId: async function () {
        let queryData = [
          {
            op: 'replace',
            path: '/doctorId',
            value: this.isCanChangeClinic ? this.manualDoctorId : this.newDoctorId,
          },
        ];
        try {
          this.editLoading = true;
          await api.updateVisitPatch(queryData, this.visitItem.id, null);
          let newVisit = await api.getVisitInfo(this.visitItem.id);
          this.editLoading = false;
          this.$emit('updateVisitItem', newVisit.data);
          this.$emit('updateCommonVisitInfo', newVisit.data);
          this.$emit('closeDialog');
        } catch (e) {
          if (e.response.status === 417) {
            methods.showGlobalSnackbar('error', 'Forbudt at tildele besøg til en anden klinik.');
          }
          this.editLoading = false;
        }
      },
    },
  };
</script>
